/// <reference types="@angular/localize" />
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.production || environment.testing || environment.development) {
  enableProdMode();
}

if ( environment.enableGA ) {

    const script1 = document.createElement('script');
    let environmentString = "";
    if(environment.gaAuth && environment.gaAuth.trim().length > 0){
      environmentString = "&gtm_auth=" + environment.gaAuth + "&gtm_preview=env-48&gtm_cookies_win=x";
    }
    script1.src = "https://www.googletagmanager.com/gtag/js?id=" + environment.gaTrackingId + environmentString;
    script1.async = true;
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date());`;
    document.head.appendChild(script2);

}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
